const SubCategoryValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (!values.category_id) {
    // You can return translation keys
    errors.category_id = "Category is required";
  }

  return errors;
};

export default SubCategoryValidation;
